import type { NotificationStates } from '@/models/enums/NotificationStates';
import type { Guid } from 'guid-typescript';

/** Notification message to display for the user. */
export type Notification = {
    /** Unique id of the notification. */
    id: Guid | string;

    /** True if the notification has been hidden from the preview. */
    isPreviewHidden: boolean;

    /** The message to display. */
    message: string;

    /** An additional text */
    additionalMessage?: string;

    /** Click event on the additional text */
    additionalOnClick?: NotificationClickEvent;

    /** State of the notification. Determines the notification apperance. */
    state: NotificationStates;

    /** Date time when the notification was created. */
    created: Date;

    /** If sticky, it will not be automatically hidden */
    sticky?: boolean;

    /** If autoremove, it will not be persisted in the store */
    autoremove?: boolean;
};

export enum NotificationClickEvent {
    Reload
}
